import { PoolRisk } from 'modules/pools/constants/PoolRisk'
import { MarketsTable } from 'modules/pools/ui/MarketsTable'

import { createRoute } from 'modules/router/utils/createRoute'

const MARKET_TABLES = [
  {
    titlePrimary: 'UNDER-COLLATERALIZED POOL',
    titleSecondary: 'ANONYMOUS BORROWERS WITH GOOD CREDIT SCORE',
    poolRisk: PoolRisk.MIDDLE,
    deposit: true,
  },
  {
    titlePrimary: 'OVER-COLLATERALIZED POOL.',
    titleSecondary: 'ALL BORROWERS',
    poolRisk: PoolRisk.HIGH,
    deposit: true,
  },
]

function RouteMarkets() {
  return (
    <>
      {MARKET_TABLES.map(table => (
        <MarketsTable
          key={`market-table-${table.poolRisk}`}
          titlePrimary={table.titlePrimary}
          titleSecondary={table.titleSecondary}
          poolRisk={table.poolRisk}
          isEnabledDeposit={table.deposit}
        />
      ))}
      <br />
    </>
  )
}

export const routeMarkets = createRoute({
  headerTitle: 'Markets',
  component: RouteMarkets,
})
